$(document).ready(function () {
  var maxDotss = 5;
  var $slider = $('.shop-by-player-block-slider');

  // --- Limit visible dots ---
  function updateVisibleDots(slick) {
    if (!slick.$dots) return;
    var $dots = slick.$dots.find('li');
    var totalDots = $dots.length;
    var activeIndex = $dots.filter('.slick-active').index();
    var start = Math.max(0, activeIndex - Math.floor(maxDotss / 2));
    var end = Math.min(totalDots, start + maxDotss);
    if (end - start < maxDotss) start = Math.max(0, end - maxDotss);
    $dots.hide();
    $dots.slice(start, end).show();
  }

  // --- Update pagination ---
  function updatePagingInfo(slick) {
    if (!slick.$dots) return;
    var $status = slick.$slider.closest('.shop-by-player').find('.pagingInfo');
    var totalDots = slick.$dots.find('li').length;
    var activeIndex = slick.$dots.find('li.slick-active').index();
    if (totalDots > 1) {
      $status.text((activeIndex + 1) + ' / ' + totalDots).show();
    } else {
      $status.hide();
    }
  }

  // --- Initialize slider only for mobile ---
  function initMobileSlider() {
    if ($(window).width() <= 768) {
      if (!$slider.hasClass('slick-initialized')) {
        $slider.slick({
          rows: 2,
          slidesPerRow: 2,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          infinite: false,
          arrows: true,
          prevArrow: '<button type="button" class="slick-prev">‹</button>',
          nextArrow: '<button type="button" class="slick-next">›</button>',
          adaptiveHeight: true
        });

        // Update pagination and dots whenever needed
        $slider.on('init reInit afterChange', function (event, slick) {
          updatePagingInfo(slick);
          updateVisibleDots(slick);
        });

        // 👇 Wait until Slick completely renders dots, then force pagination update
        setTimeout(function () {
          if ($slider.hasClass('slick-initialized')) {
            var slick = $slider.slick('getSlick');
            updatePagingInfo(slick);
            updateVisibleDots(slick);
          }
        }, 300);
      }
    } else {
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
    }
  }

  // --- Run on load + resize ---
  initMobileSlider();
  $(window).on('resize', initMobileSlider);
});
